
<template>
  <div class="filter-bar toolbar_item">
    <form class="form-inline d-flex align-items-start">
      <div class="input-group input-group-sm mb-2">
        <div class="input-group-prepend">
          <div class="input-group-text" id="btnGroupAddon" :class="{ 'text-secondary' : filterTextName }">
            <i class="far fa-search"></i>
          </div>
        </div>
        <input type="text" v-model="filterTextName" class="form-control mr-2" :placeholder="placeholder_mutable" v-on:keydown.enter.prevent data-test="filterName">
        <span v-if="filterTextName != null" id="search_clear" @click.prevent="resetFilter" data-test="filterClear">
          <i class="far fa-times-circle"></i>
        </span>
      </div>

      <div v-if="filter_type" class="d-flex align-items-start select-filters mb-2 flex-grow-1 mr-1">
        <div class="input-group-prepend">
          <div class="input-group-text" :class="{ 'text-secondary' : filterClientId.length || filterGroupId.length || filterSpecialtyId.length }">
            <i class="far fa-filter"></i>
          </div>
        </div>

<!--         <select v-if="filter_type.includes('client')" class="form-control mr-1" v-model="filterClientId">
          <option :value="null">-- All Clients --</option>
          <option v-for="client in user.client_list_all" :value="client.id">{{ client.name }}</option>
        </select>

        <select v-if="filter_type.includes('group')" class="form-control mr-1" v-model="filterGroupId">
          <option :value="null">-- All Groups --</option>
          <option v-for="group in groups.groups" :value="group.id">{{ group.display_name }}</option>
        </select>   

        <select v-if="filter_type.includes('specialty')" class="form-control mr-1" v-model="filterSpecialtyId">
          <option :value="null">-- All Specialties --</option>
          <option v-for="spec in options.specialties" :value="spec.id">{{ spec.label }}</option>
        </select>  -->

        <v-select
          v-if="filter_type.includes('client')"
          placeholder="Filter Clients"
          multiple
          label="name"
          :options="user.client_list_all"
          :reduce="name => name.id"
          v-model="filterClientId"
          class="mr-1 text-sm" 
          data-test="filterClients"
        />

        <v-select
          v-if="filter_type.includes('group')"
          placeholder="Filter Groups"
          multiple
          label="display_name"
          :options="groups.groups"
          :reduce="display_name => display_name.id"
          v-model="filterGroupId"
          class="mr-1 text-sm flex-grow-1" 
          data-test="filterGroups"
        />

        <v-select
          v-if="filter_type.includes('specialty')"
          placeholder="Filter Specialties"
          multiple
          :options="options.specialties"
          :reduce="label => label.id"
          v-model="filterSpecialtyId"
          class="mr-1 text-sm flex-grow-1" 
          data-test="filterSpecialties"
        />

      </div>

    </form>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import lodash from 'lodash';
  import debounce from 'lodash/debounce';

  export default {
    props: [
      'placeholder',
      'filter_type',
    ],

    data () {
      return {
        placeholder_mutable: this.placeholder,
        filterTextName: null,        
        filterClientId: [],
        filterGroupId: [],
        filterSpecialtyId: [],
        show_close_button: false
      }
    },

    created() {
      this.filterTextName = null;
      this.placeholder_mutable = (this.placeholder_mutable) ? this.placeholder_mutable : "Search Name...";
    }, 

    methods: {
      doFilter: _.debounce(function() {
          if (this.filterTextName == "") {
            this.resetFilter();
          }
          
          if (this.filterTextName != null) {
            this.$emit('filter-set', this.filterTextName);
          }
        }, 400),
      
      resetFilter () {
        this.filterTextName = null;
        this.$emit('filter-reset');
      }
    },

    computed: {
      ...mapState(['groups', 'options', 'user'])
    },

    watch: {
      filterTextName() {
        this.doFilter();
      },

      filterClientId() {
        this.$emit('filter-client-select', this.filterClientId);
      },

      filterGroupId() {
        this.$emit('filter-group-select', this.filterGroupId);
      },

      filterSpecialtyId() {
        this.$emit('filter-specialty-select', this.filterSpecialtyId);
      },    
    }
  }
</script>
<style>

.select-filters .input-group-text {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  padding: 0.425rem 0.5rem;
  font-size:0.765625rem;
}

.select-filters .v-select {
  min-width:150px;
  width:auto;
}

.select-filters .v-select .vs__dropdown-toggle    {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;  
  padding:0 0 4px !important;
}

.select-filters .v-select ~ .v-select .vs__dropdown-toggle    {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;  
}
</style>